import {
  getLabel,
  RECIPIENT_KIND_LABELS,
} from '../constants/notification-delivery-labels.constant';

interface Recipient {
  kind: string;
  name: string | null;
}

/**
 * Name and kind label shown for a Delivery Recipient. An External Address has
 * no name, so it shows only "Alamat eksternal".
 */
export function getRecipientDisplay(recipient: Recipient) {
  if (recipient.kind === 'external') {
    return { name: RECIPIENT_KIND_LABELS.external, kindLabel: null };
  }

  return {
    name: recipient.name ?? '-',
    kindLabel: getLabel(RECIPIENT_KIND_LABELS, recipient.kind),
  };
}
